import Immutable from "immutable";
import { AlertAction, DISMISS_ALERT, GENERATE_ALERT } from "actions/alerts/types";

export class AlertRecord extends Immutable.Record({
  isVisible: false,
  message: null,
  buttons: [],
  type: null
}) {}

export function alert(state = new AlertRecord(), action: AlertAction): AlertRecord {
  switch (action.type) {
    case GENERATE_ALERT:
      return state.merge({
        isVisible: true,
        message: action.message,
        buttons: action.buttons,
        type: action.alertType || "warning"
      });
    case DISMISS_ALERT:
      return state.clear();
    default:
      return state;
  }
}
